import Repository from '@/repositories/marketing'

export default {
	
	createStoreConnection(type, config) {
		return Repository.post(`/integrations/${type}.json`, config)
	},

	getStoresList(config){
		return Repository.get(`/crms.json`, {
			params: config
		})
	},
	
	getConnectorAuthToken(config){
		return Repository.post(`/connector/auth_tokens.json`, config)
	},

	getStoreDetail(type, storeId,config){
		return Repository.get(`/integrations/${type}/${storeId}.json`, config)
	},
	
	updateStore(type, itemId, config){
		return Repository.patch(`/integrations/${type}/${itemId}.json`, config)
	},

	deleteStore(type, storeId){
		return Repository.delete(`/integrations/${type}/${storeId}.json`)
	},

	getZapierFieldsList(accountSettingId, config){
		return Repository.get(`/zapier_custom_fields/${accountSettingId}`, config)
	},

	deleteZapierFieldsList(accountSettingId){
		return Repository.delete(`/zapier_custom_fields/${accountSettingId}.json`)
	},

	updateZapierFieldsList(accountSettingId, data, config){
		return Repository.put(`/zapier_custom_fields/${accountSettingId}.json`, data ,config)
	},

	getCarts(config){
		return Repository.get(`/carts.json`,config)
	},

	getCart(cartId, config){
		return Repository.get(`/carts/${cartId}.json`,config)
	},

	createCartConnection(config){
		return Repository.post(`/carts.json`,config)
	},

	updateCart(cartId, config){
		return Repository.patch(`/carts/${cartId}.json`, config)
	},

	deleteCart(cartId){
		return Repository.delete(`/carts/${cartId}.json`)
	},

	archiveCart(cartId){
		return Repository.put(`/carts/${cartId}/archive_cart.json`)
	},
	toggleShop(shopId, config){
		return Repository.patch(`/update_shop/${shopId}.json`, config)
	},
	getShopById(shopId, config){
		return Repository.get(`/get_shop/${shopId}.json`, config)
	},
	getIntegrationType(){
		return Repository.get(`/carts/integration_type.json`)
	}
}
